/**
 * @hidden
 * 
 * @module geo/actions/creators
 * @prefered
 * @private
 * 
 */
import {BASELAYERS_UPDATED, GEO_API_PROXY_READY, INITIALIZE_APPLICATION_STATE, 
    INITIALIZE_MAP_STATE, MAP_ENTRIES_UPDATED, MAP_EVENT, UPDATE_EXTENT, 
    UPDATE_FILTER_HISTORY_TIMESTAMP, UPDATE_FUNCTIONALITIES_STATE, 
    UPDATE_FUNCTIONALITY_STATE, UPDATE_GLOBAL_PARAMETER, 
    UPDATE_MARKERS_LIST, UPDATE_SELECTION} from '../../payload/proxy';
import {COMPONENTS_STATE_UPDATED} from '../../payload/proxy/COMPONENTS_STATE_UPDATED';
import {SERVICE_DONE} from '../../payload/proxy/SERVICE_DONE';
import {SERVICE_EXCEPTION} from '../../payload/proxy/SERVICE_EXCEPTION';
import {GeoEvent} from '../../types';
import actionCreatorFactory, {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';
import {TypeKeyActionsProxy} from '../types.key.actions.proxy';

/**
 * @private
 * @hidden
 */
const actionCreator = actionCreatorFactory(null);

/**
 * Action called after initialisation of App. Call to initialize the app store.
 * @private
 * @hidden
 */
export const INIT_APPLICATION_STATECreator = actionCreator<INITIALIZE_APPLICATION_STATE>( TypeKeyActionsProxy.INITIALIZE_APPLICATION_STATE) as ActionCreator<INITIALIZE_APPLICATION_STATE>;

/**
 * Call to set new current extent of map
 * @private
 * @hidden
 */
export const UPDATE_EXTENTCreator = actionCreator<UPDATE_EXTENT>(TypeKeyActionsProxy.UPDATE_MAP_EXTENT) as ActionCreator<UPDATE_EXTENT>;

/**
 * Call when geo application is ready to communicate with api
 * @private
 * @hidden
 */
export const GEO_API_PROXY_READYCreator =
    actionCreator<GEO_API_PROXY_READY>(TypeKeyActions.GEO_API_PROXY_READY) as
    ActionCreator<GEO_API_PROXY_READY>;
/**
 * @private
 * @hidden
 */
export const MAP_EVENTCreator =
    actionCreator<MAP_EVENT>(TypeKeyActionsProxy.MAP_EVENT) as
    ActionCreator<MAP_EVENT>;
/**
 * @private
 * @hidden
 */
export const EVENT_GEOCreator =
    actionCreator<GeoEvent>(TypeKeyActionsProxy.EVENT_GEO) as
    ActionCreator<GeoEvent>;

/**
 * @private
 * @constant
 * @internal
 * @hidden
 */
export const INITIALIZE_MAP_STATECreator = actionCreator<INITIALIZE_MAP_STATE>( TypeKeyActionsProxy.INITIALIZE_MAP_STATE) as ActionCreator<INITIALIZE_MAP_STATE>;
/**
 * @private
 * @hidden
 */
export const UPDATE_SELECTIONCreator = actionCreator<UPDATE_SELECTION>(TypeKeyActionsProxy.UPDATE_SELECTION) as ActionCreator<UPDATE_SELECTION>;
/**
 * @private
 * @hidden
 */
export const UPDATE_MARKERSCreator =
    actionCreator<UPDATE_MARKERS_LIST>(
        TypeKeyActionsProxy.UPDATE_MARKER_LIST) as
    ActionCreator<UPDATE_MARKERS_LIST>;
/**
 * @private
 * @hidden
 */
export const UPDATE_FUNCTIONALITIES_STATECreator =
    actionCreator<UPDATE_FUNCTIONALITIES_STATE>(
        TypeKeyActionsProxy.UPDATE_FUNCTIONALITIES_STATE) as
    ActionCreator<UPDATE_FUNCTIONALITIES_STATE>;
/**
 * @private
 * @hidden
 */
export const UPDATE_FUNCTIONALITY_STATECreator =
    actionCreator<UPDATE_FUNCTIONALITY_STATE>(
        TypeKeyActionsProxy.UPDATE_FUNCTIONALITY_STATE) as
    ActionCreator<UPDATE_FUNCTIONALITY_STATE>;
/**
 * @private
 * @hidden
 */
export const MAP_ENTRIES_UPDATEDCreator =
    actionCreator<MAP_ENTRIES_UPDATED>(
        TypeKeyActionsProxy.MAP_ENTRIES_UPDATED) as
    ActionCreator<MAP_ENTRIES_UPDATED>;
/**
 * Update base layers
 * @private
 * @hidden
 */
export const BASELAYERS_UPDATEDCreator =
    actionCreator<BASELAYERS_UPDATED>(TypeKeyActionsProxy.BASELAYERS_UPDATED) as
    ActionCreator<BASELAYERS_UPDATED>;
/**
 * @private
 * @hidden
 */
export const UPDATE_GLOBAL_PARAMETERCreator =
    actionCreator<UPDATE_GLOBAL_PARAMETER>(
        TypeKeyActionsProxy.UPDATE_GLOBAL_PARAMETER) as
    ActionCreator<UPDATE_GLOBAL_PARAMETER>;

/**
 * @private
 * @hidden
 */
export const UPDATE_FILTER_HISTORY_TIMESTAMPCreator =
    actionCreator<UPDATE_FILTER_HISTORY_TIMESTAMP>(
        TypeKeyActionsProxy.UPDATE_FILTER_HISTORY_TIMESTAMP) as
    ActionCreator<UPDATE_FILTER_HISTORY_TIMESTAMP>;
/**
 * @private
 * @hidden
 */
export const COMPONENTS_STATE_UPDATEDCreator =
    actionCreator<COMPONENTS_STATE_UPDATED>(
        TypeKeyActionsProxy.COMPONENTS_STATE_UPDATED) as
    ActionCreator<COMPONENTS_STATE_UPDATED>;
/**
 * @private
 * @hidden
 */
export const SERVICE_DONECreator =
    actionCreator<SERVICE_DONE>(TypeKeyActionsProxy.SERVICE_DONE) as
    ActionCreator<SERVICE_DONE>;
/**
 * @private
 * @hidden
 */
export const SERVICE_EXCEPTIONCreator =
    actionCreator<SERVICE_EXCEPTION>(TypeKeyActionsProxy.SERVICE_EXCEPTION) as
    ActionCreator<SERVICE_EXCEPTION>;